import { Api } from '../../axios-config/AxiosConfig';
import { ApiException } from '../ApiException';
import { Environment } from '../../../environment';

const getAll = async (): Promise<any[] | ApiException> => {
  try {
    const { data } = await Api.get(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/TiposBancoDados`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    if (data) {
      return data as any[];
    } else {
      return new ApiException(
        'Não foi possível consultar os tipos de banco de dados'
      );
    }
  } catch (error: any) {
    console.error('Erro ao consultar tipos de banco de dados:', error);
    return new ApiException(
      error.data.data.erro || 'Erro ao consultar tipos de banco de dados.'
    );
  }
};

export const TiposBancoDadosService = {
  getAll,
};
